<div id="active-filters" class="full-width">
  <mat-chip-set>
    <div class="flex-row justify-content-start flex-grow-1">
      <mat-chip *ngFor="let filter of filters" (removed)="delegate.removeActiveFilter(filter)">
        {{ filter.field.name | translate }} {{ filter.operator }}
        {{ filter.field.formatValue ? filter.field.formatValue(filter.value) : filter.value }}
        <button matChipRemove>
          <mat-icon fontIcon="cancel"></mat-icon>
        </button>
      </mat-chip>
    </div>

    <div class="flex-row justify-content-end flex-grow-1">
      <mat-chip highlighted (removed)="delegate.clearAllFilters(filters)" matChipRemove>
        {{ 'button.clear_filters' | translate }}
      </mat-chip>

      <mat-chip [matMenuTriggerFor]="matOptionsMenu" highlighted matChipRemove>
        <mat-icon>more_vert</mat-icon>
      </mat-chip>
    </div>
  </mat-chip-set>

  <mat-menu #matOptionsMenu="matMenu">
    <button
      mat-menu-item
      (click)="delegate.updateFilterConfig(filterConfigName, filters)"
      [disabled]="!filterConfigName"
    >
      <mat-icon>save</mat-icon>
      <span>{{ 'filter.save' | translate }}</span>
    </button>

    <button mat-menu-item (click)="delegate.createFilterConfig(filters)">
      <mat-icon>save_as</mat-icon>
      <span>{{ 'filter.save_as' | translate }}</span>
    </button>
  </mat-menu>
</div>
